import './index.less'
import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { graphicStore } from '@/commons/store/graphic-store';
import { TnEngineContext, TnEngineExtraContext, AxisT, ttf, font, ModelBase, Line, RenderMode } from 'pytha';
import { BimBaseContext, BoundingWallT, GroupType, ModelsInBimCommon, ModelsInBimStructure, ModelsInBuilding, ModelsInFire } from 'tnbimbase';
import { AmbientLight, Color, DirectionalLight, Material, Mesh, MeshBasicMaterial, Object3D, PointLight, Scene, SphereGeometry, Vector3 } from 'three';
import genUUID from '@/commons/utils/gen-uuid';
import { useState, useContext, useRef, useEffect } from 'react';
import localStore from '@/commons/store/local-store';
import axios from 'axios';
import { findGlobalUcs, findUcsInProject } from '@/api/geometry/ucs';
import { Ucs } from '@/commons/interface/geometry/ucs';
import { findAllLayersInProjectUuid, findLayersInProjectUuid } from '@/api/geometry/layer';
import { Layer } from '@/commons/interface/geometry/layer';
import { findFontGlyphs, findFontTtfs, findFontsInGraphic } from '@/api/geometry/font';
import { getTextureUrl, getTextures } from '@/api/spec-common/texture';
import { Primitive } from '@/commons/interface/geometry/primitive';
import { findPrimitivesInGraphicByTypes, findPrimitivesInProjectByModelUuids } from '@/api/geometry/primitive';
import { ModelsInStructure } from '@/passets/structure-engine/models';
// import { ModelsInHvac } from '@/passets/hvac-engine/models';
import { Texture } from '@/commons/interface/geometry/texture';
import Viewport from './viewport';
import { SystemStatus } from '@/commons/context/system-store';
import { BimContext, SystemContext } from '@/App';
import { Spin } from 'antd';
import { OnlySelectStrategy } from '@/passets/select/OnlySelectControl';
import { TINY_SELECT_STRATEGY_TYPE } from '@/passets/select/select-type';
import { MaskLoadingModal } from 'tncet-common';
import { RenderGroupType } from '@/commons/enums/render-group-type';
import { BimStatus } from '@/commons/context/bim-store';
import { getGroups, getGroupsByBuildingUuid } from '@/api/spec-common/group';
import { Group } from '@/commons/interface/speccommon/group';
import { TnGroupContext } from '@/commons/context/group-store';
import { drawEntitiesBoundingBox } from '@/commons/utils/show-entity';
import { findModelsByBuildingUuid } from '@/api/project/model';
import { Model } from '@/commons/interface/project/model';
import { ModelType } from '@/commons/enums/model-file-type';

export default function DrawPanel() {

    // 以下初始化引擎基本类
    if (graphicStore.context == null) {
        graphicStore.context = TnEngineContext.getInstance();
    }

    if (graphicStore.extraContext == null) {
        graphicStore.extraContext = TnEngineExtraContext.getInstance();
    }

    if (graphicStore.bimContext == null) {
        graphicStore.bimContext = BimBaseContext.getInstance();
    }

    const [finishInit, setFinishInit] = useState<boolean>(false);
    const { projectUuid, buildingUuid } = useParams();
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingTip, setLoadingTip] = useState<string>('');
    const [sceneUpdate, setSceneUpdate] = useState<string>(''); // 场景更新的信号
    const systemContext = useContext<SystemStatus>(SystemContext);
    const bimContext = useContext<BimStatus>(BimContext);
    // const tabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);
    const drawRef = useRef(null);
    const isInit = useRef<boolean>(false);

    const branchUuid = null

    const hideListRef = useRef<{ [key: string]: string }>({})

    useEffect(() => {
        init();
        return (() => {
            window.removeEventListener('resize', onWindowResize);
        })
    }, [projectUuid])

    useEffect(() => {
        if (!projectUuid) {
            localStore.projectUuid = null;
            systemContext.setCurrentProjectUuid(null);
            return () => { };
        }
        if (!systemContext.activeModelUuid) {
            return () => { }
        }

        // 模型变化，更新数据
        generateData();
    }, [projectUuid, systemContext.activeModelUuid, branchUuid, systemContext.updateDrawPanel])

    // useEffect(() => {
    //     if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
    //     graphicStore.extraContext.listeners.signals.onSelectChanged.add(onSelectChanged);

    //     return () => {
    //         if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
    //         graphicStore.extraContext.listeners.signals.onSelectChanged.remove(onSelectChanged);
    //     }


    // }, [graphicStore?.extraContext?.getCurrentViewEditor()])

    // const onSelectChanged = (entities: ModelBase[]) => {
    //     if (entities?.length === 0) {
    //         TnGroupContext.getInstance().clearHelpBox(true);
    //         return;
    //     }
    //     let selectedEntities = entities?.filter(item => item.isSelected) || [];
    //     if (selectedEntities?.length === 0) {
    //         TnGroupContext.getInstance().clearHelpBox(true);
    //         return;
    //     }
    //     TnGroupContext.getInstance().clearHelpBox(false);
    //     let helpBox = drawEntitiesBoundingBox(selectedEntities);
    //     TnGroupContext.getInstance().currentGroupViewObj = helpBox;
    //     TnGroupContext.getInstance().drawHelpBox(true);
    // }

    // useEffect(() => {
    //     let editor = TnEngineExtraContext.getInstance().getCurrentViewEditor()
    //     if (!editor) return
    //     let entityDict = editor.entityDict
    //     if (!(Object.keys(entityDict).length > 0)) return
    //     setLoading(true)
    //     setLoadingTip("正在切换模型")
    //     for (let uuid in entityDict) {
    //         let entity = entityDict[uuid]
    //         if (systemContext.showModelUuidList.find(item => entity?.extraData?.modelUuid == item)) {
    //             entity.hidden = false
    //         } else {
    //             entity.hidden = true
    //         }
    //     }
    //     editor.listeners.signals.needRender.dispatch("redraw")
    //     setLoading(false)
    // }, [systemContext.activeModelUuid])

    const init = () => {
        localStore.projectUuid = projectUuid;
        initScene();
        document.oncontextmenu = () => {
            return false;
        }
        if (graphicStore?.context) {
            Object.keys(ModelsInBimCommon).forEach(type => {
                graphicStore.context.modelContext.addEntitytoCtrl(type);
                graphicStore.context.modelContext.registerModel(type, ModelsInBimCommon[type]);
            })
            Object.keys(ModelsInBimStructure).forEach(type => {
                graphicStore.context.modelContext.addEntitytoCtrl(type);
                graphicStore.context.modelContext.registerModel(type, ModelsInBimStructure[type]);
            })
            Object.keys(ModelsInBuilding).forEach(type => {
                graphicStore.context.modelContext.addEntitytoCtrl(type);
                graphicStore.context.modelContext.registerModel(type, ModelsInBuilding[type]);
            })
            Object.keys(ModelsInFire).forEach(type => {
                graphicStore.context.modelContext.addEntitytoCtrl(type);
                graphicStore.context.modelContext.registerModel(type, ModelsInFire[type]);
            })
        }
        window.addEventListener('resize', onWindowResize);
    }

    const onWindowResize = () => {
        graphicStore.extraContext.listeners?.signals.windowResize.dispatch();
    }

    const initScene = () => {
        return new Promise((resolve, reject) => {
            if (graphicStore.extraContext.sceneContext.scene == null) {
                let scene = new Scene();

                // 在初始化部分添加光源
                // 添加光照
                const ambientLight = new AmbientLight(0xffffff, 1);
                scene.add(ambientLight);

                const directionalLight = new DirectionalLight(0xffffff, 1);
                directionalLight.position.set(1, 0, 0).normalize();
                directionalLight.castShadow = true; // 使光源投射阴影
                scene.add(directionalLight);

                const directionalLight1 = new DirectionalLight(0xffffff, 1);
                directionalLight1.position.set(-1, 0, 0).normalize();
                directionalLight1.castShadow = true; // 使光源投射阴影
                scene.add(directionalLight1);
                const directionalLight2 = new DirectionalLight(0xffffff, 1);
                directionalLight2.position.set(0, 1, 0).normalize();
                directionalLight2.castShadow = true; // 使光源投射阴影
                scene.add(directionalLight2);
                const directionalLight3 = new DirectionalLight(0xffffff, 1);
                directionalLight3.position.set(0, -1, 0).normalize();
                directionalLight3.castShadow = true; // 使光源投射阴影
                scene.add(directionalLight3);
                const directionalLight4 = new DirectionalLight(0xffffff, 1);
                directionalLight4.position.set(0, 0, 1).normalize();
                directionalLight4.castShadow = true; // 使光源投射阴影
                scene.add(directionalLight4);
                // const directionalLight5 = new DirectionalLight(0xffffff, 1);
                // directionalLight5.position.set(0, 0, -1).normalize();
                // directionalLight5.castShadow = true; // 使光源投射阴影
                // scene.add(directionalLight5);

                // const directionalLight2 = new DirectionalLight(0xffffff, 0.7);
                // directionalLight2.position.set(1, 3, 1).normalize();
                // directionalLight2.castShadow = true; // 使光源投射阴影
                // scene.add(directionalLight2);
                // const sphere = new SphereGeometry(0.5, 16, 8);
                // const pointLight1 = new PointLight(0xffaa00, 4000, 1000000)
                // pointLight1.position.set(0, 0, 0)
                // pointLight1.add(new Mesh(sphere, new MeshBasicMaterial({ color: 0xff0040 })));
                // scene.add(pointLight1)

                // // 创建一个光源帮助器（可选）
                // const pointLightHelper = new PointLightHelper(pointLight1, 0.5);
                // scene.add(pointLightHelper);

                graphicStore.extraContext.sceneContext.scene = scene;

                setSceneUpdate(genUUID());
                resolve(1);
            }
        })
    }

    let buildingModels: Model[] = [];
    const generateData = () => {
        // TODO 缺少登录，暂时写死，后续添加登录后删除
        localStore.userUuid = genUUID();
        if (!projectUuid) return;
        setLoading(true);
        setFinishInit(false);
        // 设置世界坐标的默认颜色
        graphicStore.context.renderContext.axisColor.set(new Color(0, 0, 0))
        // 设置鼠标默认颜色
        graphicStore.context.renderContext.cusorColor.set(new Color(0, 0, 1))
        graphicStore.context.renderContext.renderType = RenderMode.CONCEPT
        graphicStore.context.renderContext.globalEdgeColor = new Color(0, 0, 0);
        graphicStore.context.renderContext.globalSelectColor = new Color(0x1746c2);
        graphicStore.context.renderContext.globalSelectMeshColor = new Color(0x18C8FF);
        graphicStore.context.renderContext.inSelectedOnlyChangeEdgeColor = false;
        graphicStore.context.renderContext.inSelectedChangeEdgeAndMeshColor = true;
        graphicStore.context.renderContext.useGlobalSelectColor = true;
        localStore.projectUuid = projectUuid;
        initUcs().then((_) => {
            return initLayers();
        }).then((_) => {
            return initFonts();
        }).then((_) => {
            return initTexture();
        }).then((_) => {
            return initGroups();
        }).then((_) => {
            return getBuildingModels();
        }).then((_) => {
            return initModels();
        }).finally(() => {
            graphicStore.extraContext.getCurrentViewEditor()?.showAllEntities(true);
            // TODO 全局设置
            graphicStore.context.renderContext.gridLineDistanceToCircle = 3000;
            graphicStore.context.renderContext.textHeight = 300;
            graphicStore.extraContext.listeners.signals.onEditStatusChanged.dispatch();
            // 旋转视图
            graphicStore.extraContext.getCurrentViewEditor()?.viewCube.prepareAnimationData("vb");
            graphicStore.extraContext.getCurrentViewEditor().viewCube.animating = true;
            // 关掉夹点显示
            graphicStore.extraContext.getCurrentViewEditor().clampControl.enabled = false;
            graphicStore.extraContext.getCurrentViewEditor().clampControl.hidden = true;
            // 不渲染光标
            graphicStore.extraContext.getCurrentViewEditor().cursorControl.needRenderCursor = false;
            // 重新注册选择控制器
            graphicStore.extraContext.getCurrentViewEditor().selectControl.updateStrategy(OnlySelectStrategy, TINY_SELECT_STRATEGY_TYPE.ONLY_SELECT)
            setLoading(false);
            setFinishInit(true);
        })
    }

    const initUcs = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载坐标系');
            // let axisT: AxisT = new AxisT("ucs", new Vector3(0, 0, 0), new Vector3(1, 0, 0), new Vector3(0, 1, 0), new Vector3(0, 0, 1), genUUID(), true)
            // graphicStore.context.ucsContext.setUcsList([axisT]);
            // graphicStore.context.ucsContext.setCurrentUcs(axisT)
            // resolve(1)
            setLoadingTip('正在加载坐标系');
            findUcsInProject(projectUuid, systemContext.activeModelUuid, branchUuid).then(res => {
                let jsonList: Ucs[] = res.data || [];
                let ucsList = [];
                jsonList.forEach((json) => {
                    if (json.isWcs) return;
                    let ucs: AxisT = new AxisT().fromJson(json);
                    ucsList.push(ucs);
                });
                // resolve(1);
                findGlobalUcs(projectUuid, systemContext.activeModelUuid).then(res => {
                    let json = res.data;
                    let wcs = new AxisT().fromJson(json);
                    if (wcs != null) {
                        ucsList.push(wcs);
                    }
                    if (wcs == null && ucsList.length > 0) wcs = ucsList[0];
                    graphicStore.context.ucsContext.setUcsList(ucsList);
                    graphicStore.context.ucsContext.setCurrentUcs(wcs);
                    resolve(1);
                })
            })
        })
    }

    const initLayers = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载图层');
            findAllLayersInProjectUuid(projectUuid).then(res => {
                let layers: Layer[] = res.data || [];
                hideListRef.current = {}
                layers.forEach((layer) => {
                    layer.lock = false;
                    layer.hidden = false;

                    hideListRef.current[layer.uuid] = layer.name
                });
                let originLayer = layers.find((layer) => layer.originLayer && layer.projectUuid == projectUuid);
                if (originLayer == null) originLayer = layers[0];
                if (originLayer != null) {
                    graphicStore.context.layerContext.setCurrentLayerUuid(originLayer.uuid);
                    graphicStore.context.layerContext.setCurrentLayerColor(originLayer.color);
                    graphicStore.context.layerContext.setCurrentColor(originLayer.color);
                }
                graphicStore.context.layerContext.setLayers([...layers]);
                resolve(1);
            })
        });
    };

    const initFonts = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载文字样式');
            // 初始化时加载标注所用字体及默认字体
            if (!!graphicStore.extraContext.fontContext.state.dimFontData && !!graphicStore.extraContext.fontContext.state.currentFont) {
                resolve(1);
            }
            let ttfPromise = findFontTtfs();
            let fontPromise = findFontsInGraphic(projectUuid, systemContext.activeModelUuid, null);
            // 加载0~9和.所需要的glyphs
            let params = {
                unicodeFile: "times.ttf",
                rangeStart: 0,
                rangeEnd: 1919,
                bakFile: "stsong.ttf",
                text: '0123456789. \\:;/*=+-_abcdefghigklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
            };
            let glyphPromise = findFontGlyphs(params);
            axios.all([ttfPromise, fontPromise, glyphPromise]).then((res) => {
                let ttfList: ttf[] = res[0].data || [];
                graphicStore.extraContext.fontContext.generateTtfNameList(ttfList);
                let fontList: font[] = res[1].data || [];
                let defaultFont;
                fontList.forEach((font) => {
                    let ttf = ttfList.find(
                        (item) => item.name === font.fontname && item.style === font.style
                    );
                    font.ttf = ttf;
                    if (font.originFont) {
                        defaultFont = font;
                    }
                });
                graphicStore.extraContext.fontContext.setFontList(fontList);
                if (!!defaultFont) {
                    graphicStore.extraContext.fontContext.setCurrentFont(defaultFont);
                }
                graphicStore.extraContext.fontContext.setDimFontData(res[2].data);
                resolve(1);
            });
        });
    }

    const initTexture = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载纹理/材质');
            getTextures(projectUuid).then(res => {
                let textures: Texture[] = res.data || [];
                textures.forEach(texture => {
                    if (texture && texture.uuid && texture.url) {
                        let imageUrl = getTextureUrl(texture.url)
                        graphicStore.extraContext.materialContext.materialUrlMap[texture.uuid] = imageUrl;
                    }
                })
                resolve(1);
            })
        });
    }

    const initModels = (isNotGen?: boolean) => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载模型');
            if (isNotGen) {
                setLoading(true);
            }
            //将tnbimbase项目中的额外图元注册进去
            if (graphicStore.context) {
                Object.keys(ModelsInBimCommon).forEach(type => {
                    graphicStore.context.modelContext.addEntitytoCtrl(type);
                    graphicStore.context.modelContext.registerModel(type, ModelsInBimCommon[type]);
                })
                Object.keys(ModelsInStructure).forEach(type => {
                    graphicStore.context.modelContext.addEntitytoCtrl(type);
                    graphicStore.context.modelContext.registerModel(type, ModelsInStructure[type]);
                })
                Object.keys(ModelsInBimStructure).forEach(type => {
                    graphicStore.context.modelContext.addEntitytoCtrl(type);
                    graphicStore.context.modelContext.registerModel(type, ModelsInBimStructure[type]);
                })
                Object.keys(ModelsInBuilding).forEach(type => {
                    graphicStore.context.modelContext.addEntitytoCtrl(type);
                    graphicStore.context.modelContext.registerModel(type, ModelsInBuilding[type]);
                })
                Object.keys(ModelsInFire).forEach(type => {
                    graphicStore.context.modelContext.addEntitytoCtrl(type);
                    graphicStore.context.modelContext.registerModel(type, ModelsInFire[type]);
                })
            };
            let firstParam = {
                types: ['HoleT', 'DoorT', 'WindowT'],
                // modelUuid: systemContext.activeModelUuid
                modelUuids: systemContext.showModelUuidList
            }
            findPrimitivesInProjectByModelUuids(projectUuid, firstParam).then((res) => {
                if (graphicStore.extraContext.getCurrentViewEditor()) {
                    let jsonList: Primitive[] = res.data || [];
                    let tmpEntityDict: { [key: string]: ModelBase } = {};
                    let entities = jsonList.map((json: Primitive) => {
                        let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(json.properties.type))();
                        entity.fromJson(json.properties);
                        if (
                            hideListRef.current[entity?.layerUuid] == "轴网" ||
                            hideListRef.current[entity?.layerUuid] == "轴线"
                        ) {
                            return null
                        } else {
                            // 编组
                            if (entity?.group) {
                                if (entity?.group[GroupType.GROUP] && entity?.group[GroupType.GROUP]?.length > 0) {
                                    // 区域编组图元
                                    entity?.group[GroupType.GROUP]?.forEach(groupUuid => {
                                        if (groupUuid) {
                                            entity.addKeyToGroup(groupUuid);
                                        }
                                    })
                                }
                            }
                        }
                        if (json.modelUuid != systemContext.activeModelUuid) {
                            entity.unSelectable = true
                        }

                        let extraData = entity?.extraData || {};
                        extraData["modelUuid"] = json.modelUuid;
                        entity.extraData = extraData;

                        entity.addKeyToGroup(RenderGroupType.building);

                        tmpEntityDict[entity.uuid] = entity;

                        return entity;
                    });

                    graphicStore.extraContext.getCurrentViewEditor().clearEntityDict();
                    graphicStore.extraContext.getCurrentViewEditor().addObjects(entities, false);
                    bimContext.putGlobalEntityDict(tmpEntityDict);
                }
                isInit.current = true
                let secondParam = {
                    notTypes: ['HoleT', 'DoorT', 'WindowT'],
                    modelUuids: systemContext.showModelUuidList
                }
                return findPrimitivesInProjectByModelUuids(projectUuid, secondParam)
            }).then((res) => {
                if (graphicStore.extraContext.getCurrentViewEditor()) {
                    let jsonList: Primitive[] = res.data || [];
                    let tmpEntityDict: { [key: string]: ModelBase } = {};
                    let entities = [];
                    jsonList?.forEach((json: Primitive) => {
                        let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(json.properties.type))();
                        entity.fromJson(json.properties);
                        if (
                            hideListRef.current[entity?.layerUuid] == "轴网" ||
                            hideListRef.current[entity?.layerUuid] == "轴线"
                        ) {
                            return null
                        } else {
                            // 编组
                            if (entity?.group) {
                                if (entity?.group[GroupType.GROUP] && entity?.group[GroupType.GROUP]?.length > 0) {
                                    // 区域编组图元
                                    entity?.group[GroupType.GROUP]?.forEach(groupUuid => {
                                        if (groupUuid) {
                                            entity.addKeyToGroup(groupUuid);
                                        }
                                    })
                                }
                            }
                        }
                        if (json.modelUuid != systemContext.activeModelUuid) {
                            entity.unSelectable = true
                        }
                        let extraData = entity?.extraData || {}
                        extraData["modelUuid"] = json.modelUuid
                        entity.extraData = extraData
                        entity.addKeyToGroup(RenderGroupType.building);

                        tmpEntityDict[entity.uuid] = entity;

                        if (entity instanceof BoundingWallT) {
                            entity.updateHoleSolids();
                            entity.updateDoorHoleSolids();
                            entity.updateWindowHoleSolids();
                        }
                        entities.push(entity);
                    });
                    graphicStore.extraContext.getCurrentViewEditor().addObjects(entities, false);
                    bimContext.putGlobalEntityDict(tmpEntityDict);
                }
                resolve(1);
            }).finally(() => {
                graphicStore.extraContext.getCurrentViewEditor().listeners.signals.needRender.dispatch('redraw');
                let renderControl = graphicStore.extraContext.getCurrentViewEditor().renderControl
                let objectBucket = renderControl.objectRenderBucket
                const activeModel = buildingModels.find(model => model.uuid === systemContext.activeModelUuid);
                let isArch = activeModel?.type === ModelType.ARCHITECTURE;
                let extraModelUUid = "";
                if (isArch) {
                    extraModelUUid = buildingModels.find(model => model.type === ModelType.STRUCTURE)?.uuid;
                }
                for (let key in objectBucket) {
                    let renderMaps = objectBucket[key].renderMaps
                    if (renderMaps.length === 0) continue;

                    if (renderMaps[0].renderType == "TextureMesh") {
                        let renderItems = renderMaps[0].renderItems;
                        if (renderItems.length == 0) continue;
                        let model = renderItems[0].model;
                        let rootEntity = model.getRootEntity();
                        if (rootEntity?.extraData?.modelUuid == systemContext.activeModelUuid ||
                            rootEntity?.extraData?.modelUuid == extraModelUUid
                        ) {
                            continue
                        }
                    } else {
                        let models = renderMaps[0].models
                        if (models?.length == 0) {
                            continue
                        }
                        let rootEntity = models[0].getRootEntity()
                        if (rootEntity?.extraData?.modelUuid == systemContext.activeModelUuid ||
                            rootEntity?.extraData?.modelUuid == extraModelUUid) {
                            continue
                        }
                    }

                    for (let i = 0; i < renderMaps.length; i++) {

                        let mat: Material = (renderMaps[i]?.object as any)?.material;
                        if (!!mat) {
                            mat.depthTest = true;
                            mat.depthWrite = false;
                            mat.opacity = 0.1;
                            mat.vertexColors = false;
                            //@ts-ignore
                            mat.color = new Color(1, 1, 1);
                            mat.transparent = true;
                            mat.version++;
                        }
                    }
                }
                let edgeBucket = renderControl.edgeRenderBucket
                for (let key in edgeBucket) {
                    let renderMaps = edgeBucket[key].renderMaps

                    let models = renderMaps[0].models
                    if (models?.length == 0) {
                        continue
                    }
                    let rootEntity = models[0].getRootEntity()
                    if (rootEntity?.extraData?.modelUuid == systemContext.activeModelUuid ||
                        rootEntity?.extraData?.modelUuid == extraModelUUid) {
                        continue
                    }
                    for (let i = 0; i < renderMaps.length; i++) {
                        let mat = (renderMaps[i]?.object as any)?.material;
                        if (!!mat) {
                            mat.depthTest = true;
                            mat.depthWrite = false;
                            mat.opacity = 0;
                            mat.transparent = true;
                            mat.color = new Color(1, 1, 1);
                            mat.version++;
                        }
                    }
                }
                graphicStore.extraContext.getCurrentViewEditor().listeners.signals.needRender.dispatch();

                if (isNotGen) {
                    setLoading(false);
                }
            })
        });
    }

    const initGroups = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载区域');
            getGroupsByBuildingUuid(projectUuid, buildingUuid).then(res => {
                let groups: Group[] = res.data || [];
                let tree = buildTree(groups);
                let targetGroups = [];
                fillGroupLevels(tree, 1, targetGroups);
                TnGroupContext.getInstance().groups = targetGroups;
                resolve(1);
            })
        });
    }

    const getBuildingModels = () => {
        return new Promise((resolve, reject) => {
            setLoadingTip('正在加载模型列表');
            findModelsByBuildingUuid(buildingUuid).then(res => {
                buildingModels = res.data || [];
                resolve(1);
            })
        });
    }

    const buildTree = (groups: Group[]) => {
        if (groups?.length === 0) return [];
        let groupMap: { [key: string]: Group } = {};
        let tree: (Group & { level?: number })[] = [];
        // 构建dict
        groups?.forEach(group => {
            groupMap[group?.uuid] = { ...group, children: [], level: 1 };
        });
        // 构建树
        groups.forEach(group => {
            const parent = groupMap[group?.parentUuid];
            if (parent) {
                parent?.children.push(groupMap[group?.uuid]);
                groupMap[group?.uuid].level = (parent?.level || 1) + 1;
            } else {
                tree.push(groupMap[group?.uuid]);
            }
        });

        return tree;
    };

    const fillGroupLevels = (groups: Group[], currentLevel: number, targetGroups: Group[]) => {
        groups?.forEach(group => {
            group.level = currentLevel;
            targetGroups.push(group);
            if (group?.children?.length > 0) {
                fillGroupLevels(group?.children, currentLevel + 1, targetGroups);
            }
        });
    }

    return (
        <div className='draw-panel-container'>
            <div className='viewport-item'>
                {/* todo 只能用"viewport"，pythagoras库里model都用的viewport取得element，model修改后这里可以修改viewportId */}
                <Viewport sceneUpdate={sceneUpdate} viewportId='viewport' viewHelperId='viewHelper-1' cameraType={systemContext.currentCameraType} />
            </div>
            <MaskLoadingModal
                visible={loading}
                height='70px'
                loadingTip={loadingTip}
            />
        </div>
    )
}
